import { create } from 'zustand';
import { fetchAvailableResources } from './api/external-reviews-api';
import { useAlertStore } from './use-alert-store';

type ExternalReviewResource = {
  id: number;
  name: string;
};

interface Store {
  resources: ExternalReviewResource[];
  isLoading: boolean;
  fetchResources: () => Promise<void>;
}

export const useExternalReviewResourcesStore = create<Store>((set) => ({
  resources: [],
  isLoading: false,
  fetchResources: async () => {
    set({ isLoading: true });
    try {
      const resources = await fetchAvailableResources();
      set({
        resources: resources.map((item) => ({
          id: item.id,
          name: item.name,
        })),
      });
    } catch (e) {
      console.error(e);
      useAlertStore
        .getState()
        .add({ label: 'Не удалось получить список типов источников', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
  },
}));
